<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="intro-text">
    <p>
      Des contrats d'assurance <strong>pour protéger votre activité professionnelle</strong> car vous êtes légalement responsable de
      tous les préjudices que vous faites subir. Ces contrats permettent de vous protéger des produits que vous
      vendez, des services que vous proposez, de vos relations avec des tiers, et donc assurer la santé financière de
      votre entreprise.
    </p>
  </div>

  <div class="insurance-grid">
    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <h3>Responsabilité Civile</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-users"></i>
      </div>
      <h3>Responsabilité Mandataires Sociaux</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-building"></i>
      </div>
      <h3>Responsabilité Civile Décennale</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-shield"></i>
      </div>
      <h3>Protection Juridique Professionnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-cog"></i>
      </div>
      <h3>Perte d'Exploitation</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-user"></i>
      </div>
      <h3>Homme-Clé</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-euro"></i>
      </div>
      <h3>Crédit Professionnel</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-question-circle"></i>
      </div>
      <h3>Je ne sais pas quel produit il me faut</h3>
    </div>
  </div>

  <div class="important-section">
    <h2>Très Important :</h2>
    <p>
      L'assurance de l'activité de l'entreprise ou de l'activité du professionnel correspond aux responsabilités civiles et pénales de l'entreprise ou du dirigeants. Vous assurez tout ce qui
      touche à votre responsabilité vis à vis des tiers, de vos salariés, des pertes de chiffre d'affaires, et vos salariés alors il vous faudra :
    </p>
    
    <ol>
      <li>Assurer la responsabilité de l'entreprise (RC Générale, RC Professionnelle, RC Produit, RC Livraison, RC Décennale) via une <a href="#" class="highlight-link">assurance Responsabilité Civile Professionnelle</a> ou une <a href="#" class="highlight-link">assurance Responsabilité Civile Décennale</a></li>
      
      <li>Assurer la responsabilité du ou des dirigeants (litige pénal, responsabilité personnelle du dirigeant) via une <a href="#" class="highlight-link">assurance Responsabilité Civile des Mandataires Sociaux</a></li>
      
      <li>Assurer les litiges amiables ou judiciaires (Litige fournisseurs, Impayés fournisseurs, litige client, aide juridique, honoraires avocat) via une <a href="#" class="highlight-link">assurance Protection Juridique Professionnelle</a></li>
      
      <li>Assurer la perte financière (Disparition de l'homme de l'art, Fermeture administrative, Pandémie, COVID, Perte investisseur) via une <a href="#" class="highlight-link">assurance Perte d'Exploitation</a> ou une <a href="#" class="highlight-link">Assurance Homme Clé</a></li>
    </ol>

    <p class="partners-note">
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : <strong>GENERALI, APRIL, AXA SPVIE, SWISSLIFE, LIBERTY MARKET, ENTORIA, PROGEAS, HELVETIA, ZEPHIR, SOLLY AZAR, UBI, AMICI, CREDIT MUTUEL</strong>.
    </p>
  </div>

</app-page-layout>
